import { render, staticRenderFns } from "./CleanArchitectureComponent.vue?vue&type=template&id=10ac7627"
import script from "./CleanArchitectureComponent.vue?vue&type=script&lang=js"
export * from "./CleanArchitectureComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports